module.exports = __webpack_public_path__ + "static/media/app-store.04384bb2.png";